const DayDream = () => {
    return (
        <>
            <div className="dayDreams-child">
                <div className="firstChild">
                 
                    <h2>   Fuel your daydreams</h2>
                </div>
                <div className="secChild">
                    <p> Stoke your wanderlust with some dreamy photo chronicles of road trip adventures.</p>
                </div>
                <div className="thirdChild">
                    <button>Explore Travelogues</button>
                </div>
            </div>
        </>
    )
}
export default DayDream;